if (!Object.values) {
	Object.values = function(o) {
		var values = [];
		for (var i in Object.keys(o)) {
			var key = Object.keys(o)[i];
			if (o.hasOwnProperty(key)) {
				values.push(o[key]);
			}
		}
		return values;
	};
}